import { useDashboardColor } from "../../context/DashboardColorContext";
import { DisaggregatedMetric, MetricPanelProps } from "../../services/types";
import { getSortedMetrics, getSvgrMap } from "../../utils/dashboardUtils";
import BannerRibbon from "../BannerRibbon";
import MetricBarChart from "../charts/MetricBarChart";
import MetricCard from "../MetricCard";

const EconomyMetrics = ({ indicators, categorizedData, geoDetails, tab, geoTag, selectionActive }: MetricPanelProps) => {   
    const sortedMetrics = getSortedMetrics(tab, categorizedData);
    const color = useDashboardColor();
    console.log("economy data:", sortedMetrics);

    if (!indicators || indicators.length === 0) {
        return <div className="flex items-center justify-center text-color-cai-dashboard">No metrics available for {tab}.</div>;
    }

    // Define metrics for order
    const e: DisaggregatedMetric[] = sortedMetrics[0];
    const hhincome = indicators.find(i => i.id === 1384);

    return (
        <div className="mx-auto px-4 pb-8 pt-4">
            <BannerRibbon text="Economy"/>
            <div className="grid grid-cols-2 gap-4">
                {e?.map(metric => (
                    <MetricCard
                        key={metric.id}
                        metric={metric}
                        width="w-full"
                        svg={getSvgrMap(metric.id)}
                        disaggData={indicators}
                        geoDetails={geoDetails}
                        geoTag={geoTag}
                        selectionActive={selectionActive}
                    />
                ))}

                {hhincome &&
                    <div className="w-full mt-2 col-span-2">
                        <MetricBarChart 
                            metric={hhincome} 
                            disaggData={indicators}
                            geoDetails={geoDetails}
                            geoTag={geoTag}
                            selectionActive={selectionActive}
                            height="h-36" 
                            background="bg-white"
                            barColor={color}
                        />
                    </div>
                }
            </div>
        </div>
    );
}

export default EconomyMetrics;